import appConfig from '../../config';
import axios from 'axios';
import { faceTrackingStore } from '../../store';
import appEvents from '../events';
import { httpClient } from '../../utils/http-client';
export default class FaceTrackingService {
    httpClient;
    constructor() {
        this.httpClient = axios.create({
            baseURL: appConfig.faceTrackingApiUrl
        });
    }
    async createRenderRequestv2(projectDraftId) {
        const resp = await httpClient.post('/render/tracked/v2', {
            draftId: projectDraftId
        });
        return resp;
    }
    async createRenderRequest(draftId, sourceFile) {
        const resp = await httpClient.post('/render/tracked', {
            draftId,
            sourceFile,
            owner: appEvents.userId.toString()
        });
        return resp;
    }
    async requestVideoTrackingDetails(videoSrc) {
        return false;
        faceTrackingStore.update(store => ({ ...store, loading: true }));
        const resp = await this.httpClient.post('/advanced-detection', {
            video_url: videoSrc,
            user_id: appEvents.userId.toString()
        });
        return resp;
    }
    async longPollUuid(uuid) {
        return new Promise((resolve, reject) => {
            let processing = false;
            const interval = setInterval(() => {
                if (processing)
                    return;
                processing = true;
                this.httpClient
                    .get(`/advanced-detection/${uuid}`)
                    .then(resp => {
                    if (resp.status === 202)
                        return (processing = false);
                    clearInterval(interval);
                    resolve(resp.data);
                    processing = false;
                })
                    .catch(err => {
                    processing = false;
                    if (err.response.status === 102)
                        return;
                    clearInterval(interval);
                    reject(err);
                });
            }, 2000);
        });
    }
}
